import React, { Component } from 'react';
import { Button, SpeedDialAction } from 'devextreme-react';
import { isMobile } from 'react-device-detect';
import MasterLayout from './MasterLayout';
import Theme from '../theme/Theme';
//import DeviceTree from '../device/DeviceTree';

class SideDivider extends Component {
    static innerBody = <div></div>;
    static innerBodyRef = undefined;
    static forceHideSideMenu = false;

    state = {
        collapsed: this.props.collapsed === true,
        farCollapsed: this.props.farCollapsed !== false,
        bodyKey: this.props.bodyKey,
    };

    toggleCollapsing = whenDone => {
        this.setState({
            collapsed: !this.state.collapsed,
            //bodyKey: isMobile ? this.state.bodyKey + 1 : this.state.bodyKey
        }, () => {
            //this.props.onCollapsed?.(this.state.collapsed);
            console.log('++++ collpased =', this.state.collapsed);
            //if (!isMobile)
            this.props.onBodyWidthChanged?.();
            whenDone?.(this.state.collapsed);
        });
    }

    toggleFarCollapsing = () => {
        this.setState({ farCollapsed: !this.state.farCollapsed }, this.props.onBodyWidthChanged);
    }

    componentDidMount() {
        if (this.props.toggleBy)
            this.props.toggleBy.onClick = e => this.toggleCollapsing();
    }

    componentDidUpdate() {
    }

    render() {
        this.ww = isMobile ? VisualViewport.availWidth : window.innerWidth;
        this.hh = isMobile ? VisualViewport.availHeight : window.innerHeight;

        SideDivider.bodyWidth = isMobile ? this.ww : (this.ww - (this.state.collapsed ? this.props.minWidth : this.props.maxWidth)
            - (this.props.noFar === true ? 0 : this.state.farCollapsed ? this.props.minFarWidth : this.props.maxFarWidth));

        if (this.props.toggleBy)
            this.props.toggleBy.onClick = _ => this.toggleCollapsing();

        if (isMobile && this.props.collapsed)
            return (<></>);

        return (
            <div id='side_divider_container'
                key={'sdc_' + this.props.bodyKey + '_' + this.state.bodyKey}
                style={{
                    display: 'flex',
                    height: this.props.height > 0 ? this.props.height + 'px' : (this.hh - 35) + 'px',
                    direction: 'rtl', justifyContent: 'center',
                    background: Theme.col4(),
                }}>
                {!SideDivider.forceHideSideMenu && !isMobile &&
                    <div style={{
                        width: (this.state.collapsed ? this.props.minWidth : this.props.maxWidth) + 'px',
                        transition: '1s',
                        background: window.config?.THEME?.color1,
                    }}
                    >
                        {/* <div>
                        <Button icon='menu' width={this.props.minWidth} onClick={this.toggleCollapsing}
                            stylingMode='text'
                        />
                    </div> 
                    */}
                        <div>
                            {this.props.side}
                        </div>
                    </div>
                }
                <div id={'side_divider_body'} key={'side_divider_body_' + this.props.bodyKey}
                    ref={el => SideDivider.innerBodyRef = el}
                    style={{
                        width: SideDivider.bodyWidth, // = (window.innerWidth - (this.state.collapsed ? this.props.minWidth : this.props.maxWidth)
                        //- (this.state.farCollapsed ? this.props.minFarWidth : this.props.maxFarWidth)) + 'px',
                        transition: '1s',
                        overflow: 'auto',
                        //background: 'khaki',
                    }}
                >
                    {isMobile && !SideDivider.forceHideSideMenu && // ! this.state.collapsed &&
                        this.props.side
                    }
                    {this.props.body ?? SideDivider.innerBody}
                    {/* {this.props.body} */}
                </div>
                {this.props.noFar !== true &&
                    <div style={{
                        width: (this.state.farCollapsed ? this.props.minFarWidth : this.props.maxFarWidth) + 'px',
                        transition: '1s',
                        //background: 'yellowgreen',
                        overflow: 'hidden',
                    }}
                    >
                        {/* <div>
                        <Button icon='menu' width={this.props.minFarWidth} onClick={this.toggleFarCollapsing}
                            stylingMode='text'
                        />
                    </div> */}
                        <div id='side_divider_far_side'>
                            {this.props.farSide}
                        </div>
                    </div>
                }
                {this.props.noFar !== true &&
                    <SpeedDialAction icon={this.state.farCollapsed ? 'chevronright' : 'chevronleft'}
                        hint='تجهیزات' onClick={e => this.toggleFarCollapsing()} //label='تجهیزات'
                        position={{ my: 'left top', at: 'left top', of: '#side_divider_far_side', offset: '10 5' }}
                    />
                }
            </div>
        );
    }
}

export default SideDivider;